import { ResidentAppError } from '../../common/error'
import { ResidentAppErrorCode } from '../../common/types'

/**
 * The user must identify themselves before an operation can be confirmed, so
 * the error is shown as is instead of a generic operation error.
 */
export const rethrowIdentificationRequired = (error: unknown) => {
  if (
    error instanceof ResidentAppError &&
    error.errorCode === ResidentAppErrorCode.IDENTIFICATION_REQUIRED
  ) {
    throw error
  }
}
